import { MenuItem } from '@material-ui/core';
import { Field } from 'redux-form';
import { FormTextField } from '../../../../components';
import { FLOORING_FORM_COMPANIES_NAMES } from '../../../../constants';
import { required } from '../../../../utils/validators';

export const FinalizeFlooringCompanyPicker = ({ flooringForm = {} }) => {
  const { additional_forms: additionalFlooringForms = [] } = flooringForm;
  const companies = [flooringForm, ...additionalFlooringForms].map(company => company.flooring_company);
  const uniqueCompanies = Array.from(new Set(companies));

  return (
    <Field
      name="finalize_flooring_company"
      component={FormTextField}
      label="Select Flooring Company"
      fullWidth
      validate={required}
      margin="normal"
      select
    >
      {uniqueCompanies.map((company, index) => (
        <MenuItem value={company} key={index}>
          {FLOORING_FORM_COMPANIES_NAMES[company]}
        </MenuItem>
      ))}
    </Field>
  );
};
